export enum LoginPageType {
  LOGIN = 'LOGIN',
  SIGNUP = 'SIGNUP',
  RESTORE = 'RESTORE'
}
export type LoginPageTypes =
  | LoginPageType.LOGIN
  | LoginPageType.RESTORE
  | LoginPageType.SIGNUP
